(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'babel-runtime/core-js/object/keys', 'babel-runtime/regenerator', 'babel-runtime/helpers/asyncToGenerator', 'axios'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('babel-runtime/core-js/object/keys'), require('babel-runtime/regenerator'), require('babel-runtime/helpers/asyncToGenerator'), require('axios'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.keys, global.regenerator, global.asyncToGenerator, global.axios);
    global.flags = mod.exports;
  }
})(this, function (exports, _keys, _regenerator, _asyncToGenerator2, _axios) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.getSodFeatureFlags = undefined;
  exports.featureFlags = featureFlags;
  exports.getFeatureFlag = getFeatureFlag;
  exports.loadFeatureFlags = loadFeatureFlags;

  var _keys2 = _interopRequireDefault(_keys);

  var _regenerator2 = _interopRequireDefault(_regenerator);

  var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

  var _axios2 = _interopRequireDefault(_axios);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  _axios2.default.defaults.withCredentials = true;

  var FEATURE_FLAG_LOCAL_STORAGE_PREFIX = 'peachjar_app_feature_flag_';
  var flags = {
    // Default all to false...
    example_feature_1: false, // !! leave this here (for testing) !!
    example_feature_2: false, // !! leave this here (for testing) !!
    campaigns: true,
    campaigns2: false,
    cypress: false,
    portal_nav: false,
    org_uploader: false,
    credits_nav: false,
    social_share: false,
    school_finder_improvements: false
  };
  var localStorageCompatibleInMemoryStorage = {
    values: {},
    getItem: function getItem(name) {
      return typeof this.values[name] === 'string' ? this.values[name] : null;
    },
    setItem: function setItem(name, value) {
      this.values[name] = value;
    }
  };
  var storageMechanism = window.localStorage || localStorageCompatibleInMemoryStorage;

  function setFlag(name, value) {
    flags[name] = value;
    storageMechanism.setItem(FEATURE_FLAG_LOCAL_STORAGE_PREFIX + name, value.toString());
  }

  function featureFlags(name, value) {
    // If no arguments were passed, log all flag values
    if (arguments.length === 0) {
      return;
    }

    // If a name was passed, log flag value
    if (arguments.length === 1 && typeof name === 'string') {
      if (!Object.prototype.hasOwnProperty.call(flags, name)) {
        console.error('Invalid flag name. Run featureFlags() to see a list of all flags and values.');
      } else {}
    }

    // If an array of flag names was passed
    if (arguments.length === 1 && Array.isArray(name) && name.length) {
      // eslint-disable-next-line no-plusplus
      for (var i = 0, arrayLength = name.length; i < arrayLength; i++) {
        var _name$i = name[i],
            flag = _name$i.flag,
            flagValue = _name$i.value;


        if (!Object.prototype.hasOwnProperty.call(flags, flag)) {
          console.error(flag + ' is invalid. Run featureFlags() to see a list of all flags and values.');
          // eslint-disable-next-line no-continue
          continue;
        }

        // Set the flag in local storage
        setFlag(flag, flagValue);
      }

      if (window) {
        window.location.reload();
      }
    }

    // If a new value was passed
    if (arguments.length === 2 && typeof name === 'string' && typeof value === 'boolean') {
      if (!Object.prototype.hasOwnProperty.call(flags, name)) {
        console.error('Invalid flag name. Run featureFlags() to see a list of all flags and values.');
      }

      // Set the flag in local storage
      setFlag(name, value);

      // Refresh the page
      if (window) {
        window.location.reload();
      }
    }
  }

  function getFeatureFlag(name) {
    if (!Object.prototype.hasOwnProperty.call(flags, name)) {
      console.warn('Feature flag "' + name + '" not found.');
      return false;
    }

    return flags[name];
  }

  // eslint-disable-next-line no-undef
  if (window) {
    window.featureFlags = featureFlags;
  }

  var getSodFeatureFlags = exports.getSodFeatureFlags = function () {
    var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(queryEndpoint) {
      var FEATURE_FLAG_QUERY, response;
      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              FEATURE_FLAG_QUERY = '\n    query sodUserFeatureFlags {\n      sodUser {\n        featureFlags {\n          portal_nav\n          org_uploader\n        }\n      }\n    }\n  ';
              _context.prev = 1;
              _context.next = 4;
              return _axios2.default.post(queryEndpoint, {
                query: FEATURE_FLAG_QUERY
              });

            case 4:
              response = _context.sent;
              return _context.abrupt('return', response.data);

            case 8:
              _context.prev = 8;
              _context.t0 = _context['catch'](1);

              // eslint-disable-next-line no-console
              console.error('Unable to query featureFlag. ', _context.t0);
              return _context.abrupt('return', {});

            case 12:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this, [[1, 8]]);
    }));

    return function getSodFeatureFlags(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  function loadFeatureFlags() {
    // load flags
    (0, _keys2.default)(flags).forEach(function (name) {
      var storedValue = storageMechanism.getItem(FEATURE_FLAG_LOCAL_STORAGE_PREFIX + name);

      // If there is a saved value, apply it
      if (typeof storedValue === 'string') {
        flags[name] = storedValue === 'true';
      }
    });
  }

  loadFeatureFlags();
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@peachjar/components/build/flags/flags.js
// module id = 2279
// module chunks = 1